import * as React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div``

const Title = styled.div<{
  textAlign?: 'left' | 'right' | 'center'
}>`
  color: ${({ theme }) => theme.colors.black[3]};
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.1;
  margin-bottom: 0.2rem;
  text-align: ${({ textAlign }) => textAlign};
`

const Content = styled.div<{
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around'
}>`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 0.8rem;
  font-weight: 600;
  gap: 0.2rem 0.4rem;
  justify-content: ${({ justify }) => justify};
  line-height: 1.1;
`

const Item = styled.div`
  align-items: center;
  display: flex;
  gap: 0.4rem;
  white-space: nowrap;

  &:not(:last-child):after {
    content: '/';
    color: ${({ theme }) => theme.colors.black[4]};
  }
`

export interface InfoListProps {
  title?: string
  text: string[]
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around'
}

const getTextAlign = (justify: InfoListProps['justify']) => {
  switch (justify) {
    case 'flex-start':
      return 'left'
    case 'center':
      return 'center'
    case 'flex-end':
      return 'right'
    default:
      return 'left'
  }
}

export const InfoList = ({ title, text, justify = 'flex-start' }: InfoListProps) => {
  return (
    <div>
      <Title textAlign={getTextAlign(justify)}>{title}</Title>
      <Content justify={justify}>
        {text.map((item, index) => (
          <Item key={index}>{item}</Item>
        ))}
      </Content>
    </div>
  )
}
